<div class="container">
  <app-template [title]="'OBS Finalise'" *ngIf="!patient">
    <div class="no">
      <img
        style="width: 150px; height: 150px; margin-left: 20px"
        src="assets/img/error2.png"
        alt=""
      />
      <a
        routerLink="/result-finalize"
        class="waves-effect pull-right"
        style="margin-left: 20px"
      >
        <button
          type="button"
          class="button"
          mat-raised-button
          color="primary"
          style="width: 120px; margin-bottom: 30px"
        >
          Select Result
        </button>
      </a>
      No result selected please click on button above to select a result
    </div>
  </app-template>
  <app-template [title]="'OBS'" *ngIf="patient">
    <button
      class="button"
      mat-raised-button
      color="primary"
      [matMenuTriggerFor]="menu"
      style="margin-right: 30px; width: 120px"
    >
      View Info
    </button>
    <mat-menu #menu="matMenu" style="width: 400px">
      <table style="text-align: left; margin: 20px">
        <tr>
          <th style="width: 300px">Name</th>
          <td style="width: 500px">{{ FetchPatient?.first_name }}</td>
        </tr>
        <tr>
          <th>Bill No.</th>
          <td style="width: 500px">{{ patient?.bill_no }}</td>
        </tr>
        <tr>
          <th>Title</th>
          <td style="width: 500px">{{ FetchPatient?.title_id }}</td>
        </tr>
        <tr>
          <th>Gender</th>
          <td style="width: 500px">{{ FetchPatient?.sex }}</td>
        </tr>
        <tr>
          <th>Mobile</th>
          <td style="width: 500px">{{ FetchPatient?.mobile }}</td>
        </tr>
      </table>
    </mat-menu>
    <button
      *ngIf="!isSaveLoading"
      (click)="onSubmit()"
      style="width: 80px; margin-left: 30px"
      mat-raised-button
      color="primary"
    >
      Finalise
    </button>
    <button
      *ngIf="isSaveLoading"
      (click)="onSubmit()"
      style="width: 80px; margin-left: 30px"
      mat-raised-button
      color="primary"
    >
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </button>
    <div class="mat">
      <mat-tab-group>
        <mat-tab label="Ft Single">
          <app-ft-single
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
            disable="true"
          ></app-ft-single>
        </mat-tab>
        <mat-tab label="Ft Twins">
          <app-ft-twins
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
            disable="true"
          ></app-ft-twins>
        </mat-tab>
        <mat-tab label="Ft Triplets">
          <app-ft-triplet
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
            disable="true"
          ></app-ft-triplet>
        </mat-tab>
        <mat-tab label="Second Trimester">
          <app-second-trimester
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
            disable="true"
          ></app-second-trimester>
        </mat-tab>
        <mat-tab label="Third Trimester">
          <app-third-trimester
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
            disable="true"
          ></app-third-trimester>
        </mat-tab>
        <mat-tab label="View Result">
          <div style="height: 2000px">
            <div style="margin-top: 50px" #result></div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </app-template>
</div>
